export function selectPricing() {
    $(".pricing-tab").each(function(){
        const tabParent = $(this);
        const selectItem = tabParent.find("select");
        const groupClass = '.pricing-group';

        $(selectItem).change(function(){
            $(this).find("option:selected").each(function(){
                let optionValue = $(this).attr("value");
                if(optionValue){
                    $(groupClass).not("#" + optionValue).fadeOut();
                    $("#" + optionValue).fadeIn();
                } else{
                    $(groupClass).fadeOut();
                }
            });
        }).change();

    });
}



// WEBPACK FOOTER //
// ./assets/js/modules/select-pricing.js